"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.secondLoan = void 0;
var joi_1 = __importDefault(require("joi"));
exports.secondLoan = joi_1.default.object({
    registeredMortgageHolder: joi_1.default.string()
        .min(0)
        .max(30)
        .optional(),
    requiredMonthlyPaymentPrincipalInterest: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .optional(),
    unpaidBalance: joi_1.default.number()
        .min(0)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .optional(),
});
exports.default = { secondLoan: exports.secondLoan };
